module.exports = "/assets/data/d2996be4ec269fe739120ff8ee67e82a-CV10.data.json";